import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  firstOrderPackagesById,
  firstOrderShippingStatusById,
  hasFirstOrderById,
  hasFirstWeekTasks,
} from '/redux/selector/client.selector';

import {FirstWeek} from './FirstWeek';

export default connect(
  createStructuredSelector({
    hasFirstWeekTasks,
    hasFirstOrder: hasFirstOrderById,
    firstOrderShippingStatus: firstOrderShippingStatusById,
    firstOrderPackages: firstOrderPackagesById,
  }),
)(FirstWeek);
